import axios from '@axios';
// import HelperService from '@/services/HelperService';

// const helperService = new HelperService();
export default {
  sendLog(meta, description) {
    const activity = {
      app_id: 'com.madepurple.ppic',
      action: 'PurplePostLog',
      description,
      meta: JSON.stringify(meta),
      target: 'com.madepurple.ppic',
    }

    return axios.post('electron-log', JSON.stringify(activity));
  },
};
